"use strict";

var _require = require("./DefaultConverter"),
    DefaultConverter = _require.DefaultConverter;

var _require2 = require("./DateConverter"),
    DateConverter = _require2.DateConverter;

var _require3 = require("./ConvertersComposer"),
    ConvertersComposer = _require3.ConvertersComposer;

var composedConverters = new ConvertersComposer(new DateConverter(), new DefaultConverter());
module.exports = {
  convertToCustomFormat: function convertToCustomFormat(item) {
    return composedConverters.convertToCustomFormat(item);
  },
  convertFromCustomFormat: function convertFromCustomFormat(item) {
    return composedConverters.convertFromCustomFormat(item);
  }
};